export default "__VITE_ASSET__BuxunDLP__"